import { Pipe, PipeTransform } from '@angular/core';
import { SLAddress } from './entity';
import { filter, isEmpty } from 'lodash';

@Pipe({ name: 'sladdress' })
export class SLAddressPipe implements PipeTransform {
 
  transform(value: SLAddress, ...args: any[]) {
    const separator = args.length > 0 ? args[0] : '\n';

    return filter([value.line1, value.line2, value.line3, [value.zip, value.city].join(' ').trim(), value.country], s => !isEmpty(s)).join(separator);
  }
}
